export default class Platform {
    static get entries() {
        return {
            android: 'android',
            pc: 'pc',
            oem: 'oem',
        };
    }

    static get ANDROID() {
        return this.entries.android;
    }

    static get PC() {
        return this.entries.pc;
    }

    static get OEM() {
        return this.entries.oem;
    }
}
